<div class="container">
  <div class="row">
    <div class="col-12">
      <h1 class="page-title">{{ "RIDP_TITLE" | globalTranslate }}</h1>
    </div>
  </div>
  <div class="bg-custom-register">
    <nh-alert type="warning" [isOpen]="displayCantVerifyBanner()">
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
            alt="warning"
          />
        </div>
        <div class="col message">
          <span [innerHTML]="'RIDP_CANT_VERIFY_ALERT' | globalTranslate"></span
          ><span>{{ this.minutes }}</span
          ><span [innerHTML]="'RIDP_MINUTES' | globalTranslate"></span>
        </div>
      </div>
    </nh-alert>
    <h1 class="section-header">{{ "RIDP_TITLE" | globalTranslate }}</h1>
    <hr />
    <p>{{ "RIDP_INSTRUCTIONS" | globalTranslate }}</p>
    <p [innerHTML]="'RIDP_NOTE' | globalTranslate"></p>
    <br />
    @if (isDataLoaded) {
    <section>
      <div class="row me-1">
        <div class="col-md-12 ml-1">
          <div [formGroup]="ridpVerifyAccount">
            <div class="row g-3">
              <div class="col-sm-8 col-lg-4 col-md-3">
                <nh-field
                  id="firstName"
                  [isRow]="true"
                  label="{{ 'FIRST_NAME' | globalTranslate }}"
                >
                  <input
                    type="text"
                    formControlName="firstName"
                    [attr.aria-label]="'FIRST_NAME' | globalTranslate"
                    name="firstName"
                    class="form-control"
                    required
                  />
                </nh-field>
              </div>
              <div class="col-sm-4 col-lg-3 col-md-4">
                <nh-field
                  id="middleName"
                  [isRow]="true"
                  label="{{ 'RIDP_MIDDLE_NAME' | globalTranslate }}"
                  [mandatory]="false"
                  [attr.aria-required]="false"
                >
                  <input
                    [attr.aria-label]="'RIDP_MIDDLE_NAME' | globalTranslate"
                    formControlName="middleName"
                    type="text"
                    name="middleName"
                    class="form-control"
                  />
                </nh-field>
              </div>
              <div class="col-sm-8 col-lg-3 col-md-3">
                <nh-field
                  id="lastName"
                  [isRow]="true"
                  label="{{ 'RIDP_LAST_NAME' | globalTranslate }}"
                >
                  <input
                    [attr.aria-label]="'RIDP_LAST_NAME' | globalTranslate"
                    formControlName="lastName"
                    type="text"
                    name="lastName"
                    class="form-control"
                    maxlength="45"
                    required
                  />
                </nh-field>
              </div>
              @if (tables?.RIDPNAMESUFFIX?.length) {
              <div class="col-sm-4 col-lg-2 col-md-2">
                <nh-field
                  id="suffix"
                  [isRow]="true"
                  label="{{ 'SUFFIX' | globalTranslate }}"
                  [mandatory]="false"
                  [attr.aria-required]="false"
                >
                  <select
                    [attr.aria-label]="'SUFFIX' | globalTranslate"
                    [items]="tableSuffix"
                    formControlName="suffix"
                    nh
                    name="suffix"
                  ></select>
                </nh-field>
              </div>
              }
            </div>
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <nh-field
                  id="birthdate_ridp"
                  [isRow]="true"
                  label="{{ 'DOB' | globalTranslate }}"
                >
                  <nh-datepicker>
                    <input
                      [attr.aria-label]="'DOB' | globalTranslate"
                      type="text"
                      [attr.aria-required]="true"
                      formControlName="dateOfBirth"
                      class="form-control"
                      [minDate]="minimumDate"
                      [maxDate]="today"
                      bsDatepicker
                      nh
                      required
                    />
                  </nh-datepicker>
                </nh-field>
              </div>
              <div class="col-12 col-md-6">
                <nh-field
                  id="ssn_ridp"
                  [isRow]="true"
                  label="{{ 'SSN' | globalTranslate }}"
                  [mandatory]="false"
                  [attr.aria-required]="false"
                >
                  <input
                    type="text"
                    [attr.aria-label]="'SSN' | globalTranslate"
                    formControlName="ssn"
                    class="form-control"
                    placeholder="XXX-XX-XXXX"
                    mask="000-00-0000"
                  />
                </nh-field>
              </div>
            </div>
            <nh-alert type="warning" [isOpen]="checkSSNAlertMessageDIssplay()">
              <div class="row">
                <div class="col-auto icon">
                  <img
                    src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                    alt="warning"
                  />
                </div>
                <div class="col message">
                  <span> {{ "RIDP_SSN_ALERT" | globalTranslate }} </span>
                </div>
              </div>
            </nh-alert>
            <h2 class="section-header">{{ "ADDR_INFO" | globalTranslate }}</h2>
            <hr />
            @if (tables?.STATE?.length && tables?.COUNTY?.length) {
            <div [formGroup]="ridpVerifyAccount">
              <nh-name-address
                [addressLine1ToolTip]="false"
                [addressLine2ToolTip]="false"
                [address]="ridpVerifyAccount.get('ridpAddress')"
                [tables]="tables"
                [stateDefault]="stateDefault"
                [addressFieldMandatory]="true"
                [addressname]="'ridp_Address'"
                [separateZipFields]="true"
                [cityMaxLength]="38"
                [addressLine1MaxLength]="40"
                [addressLine2MaxLength]="19"
              ></nh-name-address>
            </div>
            }
            <hr />
            <h3 class="section-header">
              {{ "CONTACT_INFO" | globalTranslate }}
            </h3>
            <div class="row">
              <div class="row g-3">
                <div class="col-12 col-md-6">
                  <nh-field
                    [isRow]="true"
                    [mandatory]="true"
                    [attr.aria-required]="true"
                    label="{{ 'PRIMARY_PHONE' | globalTranslate }}"
                  >
                    <input
                      type="text"
                      name="home"
                      formControlName="phoneNumber"
                      class="form-control"
                      mask="000-000-0000"
                      placeholder="XXX-XXX-XXXX"
                      [attr.aria-label]="'PRIMARY_PHONE' | globalTranslate"
                      required
                    />
                  </nh-field>
                </div>
                <div class="col-12 col-md-6">
                  <nh-field
                    [isRow]="true"
                    label="{{ 'EMAIL_ADDRESS' | globalTranslate }}"
                    [mandatory]="false"
                    [attr.aria-required]="false"
                    class="label-section"
                  >
                    <input
                      id="ra_email"
                      type="email"
                      formControlName="emailAddress"
                      name="email"
                      [attr.aria-label]="'EMAIL_ADDRESS' | globalTranslate"
                      class="form-control"
                      placeholder="{{ 'EMAIL_PLACEHOLDER' | globalTranslate }}"
                    />
                  </nh-field>
                </div>
              </div>
            </div>
            <p>
              <span
                ><b [innerHTML]="'RIPD_IMP_NOTE' | globalTranslate"></b
              ></span>
              <span [innerHTML]="'RIPD_IMP_NOTE_01' | globalTranslate"></span>
              <span
                ><b [innerHTML]="'RIPD_IMP_NOTE_02' | globalTranslate"></b
              ></span>
              <span [innerHTML]="'RIPD_IMP_NOTE_03' | globalTranslate"></span>
              <span
                ><b [innerHTML]="'RIPD_IMP_NOTE_04' | globalTranslate"></b
              ></span>
              <span [innerHTML]="'RIPD_IMP_NOTE_05' | globalTranslate"></span>
            </p>
            <br />
            <div class="checkbox-label">
              <input
                style="margin-right: 14px"
                type="checkbox"
                name="acceptTermsRidp"
                formControlName="ridpConsent"
                checkedValue="E"
                (change)="deselect($event)"
                [attr.aria-label]="'RIDP_CHECKBOX_2' | globalTranslate"
              />
              <span class="visually-hidden">{{
                "required" | globalTranslate
              }}</span>
              <span
                style="padding-right: 4px"
                class="text-danger ng-star-inserted"
                aria-hidden="true"
                >*</span
              >
              <p [innerHTML]="'RIDP_CHECKBOX_2' | globalTranslate"></p>
            </div>
            <div class="checkbox-label">
              <input
                style="margin-right: 14px"
                type="checkbox"
                name="acceptTermsRidp2"
                formControlName="ridpConsent2"
                checkedValue="E"
                (change)="deselectTwo($event)"
                [attr.aria-label]="'RIDP_CHECKBOX' | globalTranslate"
              />
              <span class="visually-hidden">{{
                "required" | globalTranslate
              }}</span>
              <span
                style="padding-right: 4px"
                class="text-danger ng-star-inserted"
                aria-hidden="true"
                >*</span
              >
              <p [innerHTML]="'RIDP_CHECKBOX' | globalTranslate"></p>
            </div>
            <mat-accordion displayMode="" multi class="ridp-consent-accordion">
              <mat-expansion-panel
                class="ridp-expansion-panel"
                [expanded]="true"
              >
                <mat-expansion-panel-header
                  role="button"
                  tabindex="0"
                  class="mat-row ridp-expansion-header"
                  hideToggle
                >
                  <mat-panel-title class="ridp-panel-title">
                    <p class="consent-text">
                      {{ "VERIFY_IDENTITY_INFO_TEXT_01" | globalTranslate }}
                    </p>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="ridp-expanded-content">
                  <div class="consent-section">
                    <h4 class="consent-heading">
                      {{ "VERIFY_IDENTITY_INFO_TEXT_02" | globalTranslate }}
                    </h4>
                    <ul class="consent-list" role="list">
                      <li
                        role="listitem"
                        [innerHTML]="
                          'VERIFY_IDENTITY_INFO_TEXT_03' | globalTranslate
                        "
                      ></li>
                      <li role="listitem">
                        <span
                          [innerHTML]="
                            'VERIFY_IDENTITY_INFO_TEXT_04' | globalTranslate
                          "
                        ></span>
                        @if (translatedLang !== 'en' && globalLang === null) {
                        <span>
                          <span
                            [innerHTML]="
                              'VERIFY_IDENTITY_INFO_TEXT_04_01'
                                | globalTranslate
                            "
                          ></span>
                        </span>
                        } @else {
                        <strong
                          ><span
                            [innerHTML]="
                              'VERIFY_IDENTITY_INFO_TEXT_04_01'
                                | globalTranslate
                            "
                          ></span
                        ></strong>
                        }
                        <span
                          [innerHTML]="
                            'VERIFY_IDENTITY_INFO_TEXT_04_02' | globalTranslate
                          "
                        ></span>
                      </li>
                    </ul>
                    <p class="additional-info d-none d-lg-block">
                      {{ "VERIFY_IDENTITY_INFO_TEXT_05" | globalTranslate }}
                      <b
                        ><a
                          href="https://www.tn.gov/tenncare/legal/privacy-policies.html"
                          target="_blank"
                          >{{
                            "VERIFY_IDENTITY_INFO_TEXT_05_01" | globalTranslate
                          }}</a
                        ></b
                      >.
                      {{ "VERIFY_IDENTITY_INFO_TEXT_05_02" | globalTranslate }}
                      <span class="phone-number"><b>1-855-259-0701</b></span
                      >.
                    </p>
                    <p class="additional-info nh-table-mobile d-lg-none">
                      {{ "VERIFY_IDENTITY_INFO_TEXT_05" | globalTranslate }}
                      <b>
                        <a
                          href="https://www.tn.gov/tenncare/legal/privacy-policies.html"
                          target="_blank"
                          >{{
                            "VERIFY_IDENTITY_INFO_TEXT_05_01" | globalTranslate
                          }}</a
                        ></b
                      >.
                      {{ "VERIFY_IDENTITY_INFO_TEXT_05_02" | globalTranslate }}
                      <a href="tel:855-259-0701" class="phone-link"
                        ><span class="phone-number"
                          ><b>1-855-259-0701</b></span
                        ></a
                      >.
                    </p>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </div>
    </section>
    }
  </div>
  <div class="row m-auto mb-3 ml-1 ms-1 pt-4">
    <button
      id="continue"
      (click)="onNext()"
      [ngClass]="{
        'font-translate': decreaseFont(),
        'extrafont-translate': decreaseFontExtra()
      }"
      [disabled]="
        !isFormValid() || displayCantVerifyBanner() || disbleVerifyIdentity
      "
      class="btn btn-secondary col-sm-12 col-md-4 col-lg-3 offset-md-8"
    >
      {{ "RIDP_BTN" | globalTranslate }}
    </button>
  </div>
</div>
